/* global gdAlertify */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../config/axiosConfig";

const ConfigParametros = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [porcentaje, setPorcentaje] = useState("");

    useEffect(() => {
        if (id !== "nuevo") {
            fetchPorcentaje();
        }
    }, [id]);

    const fetchPorcentaje = async () => {
        try {
            const { data } = await axiosInstance.get(`/perfiles/ver/${id}`);
            setPorcentaje(data.data.porcentaje_sii || "");
        } catch (error) {
            console.error("Error al obtener el porcentaje", error);
        }
    };

    const guardarPorcentaje = async () => {
        try {
            const payload = {
                id,
                porcentaje_sii: porcentaje,
            };
            await axiosInstance.post(`/perfiles/guardar`, payload);
            navigate("/perfiles");
        } catch (error) {
            console.error("Error al guardar el porcentaje", error);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">{id === "nuevo" ? "Nuevo Registro" : `Editar Porcentaje SII`}</h4>
                </div>
                <div className="card-body">
                    <form>
                        <div className="mb-3">
                            <label className="form-label">Porcentaje SII</label>
                            <input
                                type="number"
                                step="0.01"
                                className="form-control"
                                value={porcentaje}
                                onChange={(e) => setPorcentaje(e.target.value)}
                                required
                            />
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                            <button type="button" className="btn btn-success" onClick={guardarPorcentaje}>
                                Guardar
                            </button>
                            <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate("/perfiles")}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ConfigParametros;
